var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',_vm._g(_vm._b({},'el-dialog',_vm.$attrs,false),_vm.$listeners),[_c('div',[_vm._t("title")],2),_c('div',[_vm._t("default")],2),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }